<script lang="ts">
  import { signInWithGitHub, signInWithGoogle, signInWithEmail } from '../stores/auth.svelte.ts';

  let email = $state('');
  let magicSent = $state(false);
  let loading = $state(false);
  let error = $state<string | null>(null);

  async function handleMagicLink() {
    if (!email.trim()) return;
    loading = true;
    error = null;
    const { error: err } = await signInWithEmail(email);
    loading = false;
    if (err) { error = err.message; return; }
    magicSent = true;
  }
</script>

<div class="login-root">
  <div class="orb orb-1"></div>
  <div class="orb orb-2"></div>
  <div class="login-card">
    <div class="login-logo">
      <svg width="36" height="36" viewBox="0 0 36 36" fill="none">
        <rect width="36" height="36" rx="8" fill="oklch(0.72 0.28 310 / 0.15)"/>
        <rect x="8" y="8" width="20" height="20" rx="4" stroke="oklch(0.72 0.28 310)" stroke-width="2" fill="none"/>
        <circle cx="18" cy="18" r="4" fill="oklch(0.72 0.28 310)"/>
      </svg>
      <span class="login-brand">Agentboard</span>
    </div>

    <h1 class="login-title">Welcome back</h1>
    <p class="login-sub">Sign in to your workspace</p>

    <div class="oauth-buttons">
      <button class="oauth-btn" onclick={signInWithGitHub}>
        <svg class="oauth-icon" viewBox="0 0 24 24" width="18" height="18" fill="currentColor">
          <path d="M12 0C5.37 0 0 5.37 0 12c0 5.31 3.435 9.795 8.205 11.385.6.105.825-.255.825-.57 0-.285-.015-1.23-.015-2.235-3.015.555-3.795-.735-4.035-1.41-.135-.345-.72-1.41-1.23-1.695-.42-.225-1.02-.78-.015-.795.945-.015 1.62.87 1.845 1.23 1.08 1.815 2.805 1.305 3.495.99.105-.78.42-1.305.765-1.605-2.67-.3-5.46-1.335-5.46-5.925 0-1.305.465-2.385 1.23-3.225-.12-.3-.54-1.53.12-3.18 0 0 1.005-.315 3.3 1.23.96-.27 1.98-.405 3-.405s2.04.135 3 .405c2.295-1.56 3.3-1.23 3.3-1.23.66 1.65.24 2.88.12 3.18.765.84 1.23 1.905 1.23 3.225 0 4.605-2.805 5.625-5.475 5.925.435.375.81 1.095.81 2.22 0 1.605-.015 2.895-.015 3.3 0 .315.225.69.825.57A12.02 12.02 0 0 0 24 12c0-6.63-5.37-12-12-12z"/>
        </svg>
        Continue with GitHub
      </button>
      <button class="oauth-btn" onclick={signInWithGoogle}>
        <svg class="oauth-icon" viewBox="0 0 24 24" width="18" height="18">
          <path fill="oklch(0.65 0.20 30)" d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92c-.26 1.37-1.04 2.53-2.21 3.31v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.09z"/>
          <path fill="oklch(0.55 0.20 145)" d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z"/>
          <path fill="oklch(0.60 0.22 60)" d="M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.07H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.93l2.85-2.22.81-.62z"/>
          <path fill="oklch(0.55 0.22 25)" d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84c.87-2.6 3.3-4.53 6.16-4.53z"/>
        </svg>
        Continue with Google
      </button>
    </div>

    <div class="divider"><span>or</span></div>

    {#if magicSent}
      <div class="magic-sent">
        <span class="magic-icon">✉</span>
        <p>Check your email — we sent a magic link to <strong>{email}</strong></p>
        <button class="back-btn" onclick={() => { magicSent = false; email = ''; }}>Try a different email</button>
      </div>
    {:else}
      <form class="magic-form" onsubmit={(e) => { e.preventDefault(); void handleMagicLink(); }}>
        <input
          class="email-input"
          type="email"
          bind:value={email}
          placeholder="you@company.com"
          disabled={loading}
          required
        />
        {#if error}
          <p class="login-error">{error}</p>
        {/if}
        <button class="magic-btn" type="submit" disabled={loading || !email.trim()}>
          {loading ? 'Sending…' : 'Send magic link'}
        </button>
      </form>
    {/if}

    <p class="login-footer">
      By signing in you agree to our terms. Self-hosted users don't need an account.
    </p>
  </div>
</div>

<style>
  .login-root {
    position: fixed;
    inset: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    background: oklch(0.07 0.015 275);
    padding: 1.5rem;
    overflow: hidden;
    z-index: 9999;
  }

  .orb {
    position: fixed;
    border-radius: 50%;
    pointer-events: none;
    filter: blur(100px);
    z-index: 0;
  }
  .orb-1 {
    width: 500px; height: 500px;
    background: radial-gradient(circle, oklch(0.55 0.28 310 / 0.16) 0%, transparent 70%);
    top: -150px; left: -80px;
  }
  .orb-2 {
    width: 400px; height: 400px;
    background: radial-gradient(circle, oklch(0.60 0.25 340 / 0.10) 0%, transparent 70%);
    bottom: -80px; right: -60px;
  }

  .login-card {
    position: relative;
    z-index: 1;
    background: oklch(0.11 0.02 275);
    border: 1px solid oklch(0.25 0.04 275 / 0.40);
    border-radius: 12px;
    padding: 2.5rem;
    max-width: 400px;
    width: 100%;
    display: flex;
    flex-direction: column;
    gap: 1.25rem;
  }

  .login-logo {
    display: flex;
    align-items: center;
    gap: 0.75rem;
  }

  .login-brand {
    color: oklch(0.96 0.08 310);
    font-size: 1.25rem;
    font-weight: 700;
    letter-spacing: -0.01em;
  }

  .login-title {
    color: oklch(0.96 0.05 310);
    font-size: 1.5rem;
    font-weight: 700;
    letter-spacing: -0.02em;
    margin: 0;
  }

  .login-sub {
    color: oklch(0.55 0.04 310 / 0.7);
    font-size: 0.88rem;
    margin: -0.75rem 0 0;
  }

  .oauth-buttons {
    display: flex;
    flex-direction: column;
    gap: 0.625rem;
  }

  .oauth-btn {
    display: flex;
    align-items: center;
    gap: 0.625rem;
    padding: 0.625rem 1rem;
    background: oklch(0.15 0.025 275);
    border: 1px solid oklch(0.28 0.04 275 / 0.50);
    border-radius: 8px;
    color: oklch(0.92 0.02 310);
    font-size: 0.9rem;
    font-weight: 500;
    cursor: pointer;
    transition: background 0.15s, border-color 0.15s;
    width: 100%;
  }

  .oauth-btn:hover {
    background: oklch(0.18 0.04 310 / 0.40);
    border-color: oklch(0.72 0.28 310 / 0.35);
  }

  .oauth-icon {
    flex-shrink: 0;
  }

  .divider {
    display: flex;
    align-items: center;
    gap: 0.75rem;
    color: oklch(0.40 0.04 275 / 0.60);
    font-size: 0.8rem;
  }

  .divider::before,
  .divider::after {
    content: '';
    flex: 1;
    height: 1px;
    background: oklch(0.25 0.04 275 / 0.35);
  }

  .magic-form {
    display: flex;
    flex-direction: column;
    gap: 0.75rem;
  }

  .email-input {
    width: 100%;
    padding: 0.625rem 0.875rem;
    background: oklch(0.15 0.025 275);
    border: 1px solid oklch(0.28 0.04 275 / 0.50);
    border-radius: 8px;
    color: oklch(0.93 0.015 310);
    font-size: 0.9rem;
    outline: none;
    box-sizing: border-box;
    transition: border-color 0.15s;
  }

  .email-input::placeholder {
    color: oklch(0.45 0.02 310 / 0.5);
  }

  .email-input:focus {
    border-color: oklch(0.72 0.28 310 / 0.60);
  }

  .email-input:disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }

  .login-error {
    color: oklch(0.75 0.24 25);
    font-size: 0.82rem;
    margin: 0;
  }

  .magic-btn {
    padding: 0.625rem 1rem;
    background: oklch(0.72 0.28 310);
    border: none;
    border-radius: 8px;
    color: oklch(0.08 0.015 275);
    font-size: 0.9rem;
    font-weight: 600;
    cursor: pointer;
    transition: background 0.15s, opacity 0.15s;
  }

  .magic-btn:hover:not(:disabled) {
    background: oklch(0.78 0.26 310);
  }

  .magic-btn:disabled {
    opacity: 0.45;
    cursor: not-allowed;
  }

  .magic-sent {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 0.75rem;
    text-align: center;
    padding: 1rem 0;
  }

  .magic-icon {
    font-size: 2rem;
  }

  .magic-sent p {
    color: oklch(0.80 0.03 310);
    font-size: 0.9rem;
    margin: 0;
    line-height: 1.5;
  }

  .magic-sent strong {
    color: oklch(0.93 0.015 310);
  }

  .back-btn {
    background: none;
    border: none;
    color: oklch(0.72 0.28 310);
    font-size: 0.85rem;
    cursor: pointer;
    text-decoration: underline;
    padding: 0;
  }

  .back-btn:hover {
    color: oklch(0.82 0.24 310);
  }

  .login-footer {
    color: oklch(0.40 0.04 310 / 0.5);
    font-size: 0.72rem;
    text-align: center;
    margin: 0;
    line-height: 1.5;
  }
</style>
